import {useDispatch} from "react-redux";
import {clearNewlyAddedCompany, getCompanies} from "../../redux/actions/companyActions";
import {useCompanySelector} from "../../redux/reducers/companyReducer";
import {useState} from "react";
import {message, Modal} from "antd";
import api from "../../api/api";
import {useThemeSelector} from "../../redux/reducers/themeReducer";
import useWindowSize from "../../helpers/useWindowSize";
import breakpoints from "../../constants/breakpoints";
import {COMPANY_DELETE_URL, companyHasSoftwareProductDelete_URL} from "../../constants/urlConfig";

const useController = ({history}) => {
    const dispatch = useDispatch();
    const {loading, companies} = useCompanySelector();
    const {darkMode} = useThemeSelector();

    const size = useWindowSize();
    const isDeviceSmall = size.width < breakpoints.sm;

    const [addCompanyClicked, setAddCompanyClicked] = useState(false);

    const [companyToShowDetailsFor, setCompanyToShowDetailsFor] = useState(null);
    const [companyDetailsVisible, isCompanyDetailsVisible] = useState(false);
    const toggleCompanyDetails = (companyDetailsVisible, companyToShowDetailsFor) => {
        isCompanyDetailsVisible(companyDetailsVisible);
        setCompanyToShowDetailsFor(companyToShowDetailsFor);
    };

    return {
        companyToShowDetailsFor,
        toggleCompanyDetails,
        companyDetailsVisible,

        isDeviceSmall,
        companies,
        addCompanyClicked,
        setAddCompanyClicked: addCompanyClicked => {
            setAddCompanyClicked(addCompanyClicked);
            dispatch(clearNewlyAddedCompany());
            history.push('addCompany')
        },
        loading,
        getCompanies: () => {
            dispatch(getCompanies())
        },
        onEditClick: record => history.push('editCompany/' + record.id),
        onLicencesClick: company => history.push('companyLicences/' + company.id),
        onDeleteClick: record => {
            const {confirm} = Modal;

            confirm({
                className: darkMode && 'dark-mode',
                title: `Do you want to delete ${record.companyName}?`,
                content: 'This record will be removed from data source',
                onOk() {
                    const link = COMPANY_DELETE_URL.replace('{id}', record.id);

                    if (link) {
                        api.delete(link).then(resp => {
                            message.success({
                                content: "Record successfully deleted.",
                                className: darkMode && "dark-mode"
                            });
                            dispatch(getCompanies())
                        }).catch(err => {
                            message.error({
                                content: "Record was not deleted.",
                                className: darkMode && "dark-mode"
                            });
                        })
                    } else {
                        message.error({
                            content: "Something went wrong",
                            className: darkMode && "dark-mode"
                        });
                    }
                }
            });
        },
        onRemoveProductFromCompany: ({companyName, companyHasSoftwareProductId, softwareProductCode, softwareProductName}) => {
            const {confirm} = Modal;

            confirm({
                className: darkMode && 'dark-mode',
                title: `Do you want to remove ${softwareProductName} from company ${companyName}?`,
                content: 'This record will be removed from data source',
                onOk() {
                    const link = companyHasSoftwareProductDelete_URL.replace('{id}', companyHasSoftwareProductId);

                    if (link) {
                        api.delete(link).then(resp => {
                            message.success({
                                content: "Record successfully deleted.",
                                className: darkMode && "dark-mode"
                            });
                            dispatch(getCompanies())
                        }).catch(err => {
                            message.error({
                                content: "Record was not deleted.",
                                className: darkMode && "dark-mode"
                            });
                        })
                    } else {
                        message.error({
                            content: "Something went wrong",
                            className: darkMode && "dark-mode"
                        });
                    }
                }
            });
        }
    }
};

export default useController;